module.exports = __webpack_public_path__ + "static/media/ShiftToReimbursement.0b6e9afe.svg";